import { useEffect, useState } from "react";

const getWidth = () => window.innerWidth;

export default function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(getWidth());

    useEffect(() => {
        const onResize = () => {
            setWindowWidth(getWidth());
        }

        window.addEventListener("resize", onResize);
    
        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);
    
    return windowWidth;
}